class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems =
        this.closest('cart-items') || this.closest('cart-drawer-items');

      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.doesSaturdayHaveAdditionalCost = false;

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') ||
      document.getElementById('CartDrawer-LineItemStatus');

    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return;
    }

    this.dateFormatOptions = { weekday: 'long', month: 'long', day: 'numeric' };
    const deliveryDatePicker = document.querySelector('.delivery-date-picker select[name="attributes[Delivery Date]"]');

    this.saturdayCost = deliveryDatePicker?.dataset?.saturdayCost || 0;

    if (!document.querySelector('.delivery-date-picker')) {
      return;
    }

    document.querySelector('.delivery-date-picker')?.addEventListener('change', (event) => {
      if (event.target.classList.contains('picker-delivery-date')) {
        this.saveCartDateAndNote();
      }
    });

    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      this.populateDeliveryDates();
    }).bind(this);

    subscribe('delivery-date-update', (event) => {
      this.populateDeliveryDates();
    }).bind(this);

    this.populateDeliveryDates();


  }

  cartUpdateUnsubscriber = undefined;
  saveCartDateAndNote() {

    var event = new Event('input', {
      bubbles: true,
      cancelable: true,
    });
    document.querySelector('cart-note').dispatchEvent(event);
  }
  cartContainsAFreshPreOrder() {
    const freshItems = document.querySelectorAll('#main-cart-items tr.cart-item[data-type="Fresh Fish"]');
    return freshItems.length > 0;
  }

  populateDeliveryDates() {
    const deliveryDatePicker = document.querySelector('.delivery-date-picker select[name="attributes[Delivery Date]"]');
    this.saturdayCost = deliveryDatePicker?.dataset?.saturdayCost || 0;

    const msInADay = 24 * 60 * 60 * 1000;
    const hasNonFutureFresh = deliveryDatePicker.dataset.hasFresh !== undefined && deliveryDatePicker.dataset.hasFresh === 'true';
    const hasFutureItem = deliveryDatePicker.dataset.hasFreshFuture !== undefined && deliveryDatePicker.dataset.hasFreshFuture === 'true';
    const hasBox = deliveryDatePicker.dataset.hasBox !== undefined && deliveryDatePicker.dataset.hasBox === 'true';

    const currentDateTime = new Date();

    const daysToAllowSelectable = this.cartContainsAFreshPreOrder() ? 1 : 7;
    const excludedDates = (deliveryDatePicker.dataset.datesExclude || '').split(',').map(d => d.trim());
    const includedDates = (deliveryDatePicker.dataset.datesInclude || '').split(',').map(d => d.trim());
    const selectedDeliveryDate = deliveryDatePicker.dataset.value || '';
    const datesAdded = [];

    const cutoffTimeForNextDayAvailability = (currentDateTime.getUTCDay() == 5) ? 12 : 14;

    // If we are past the cutoff time, then add another day to first available delivery day
    var offsetForOrderingAfterCutoff = currentDateTime.getHours() < cutoffTimeForNextDayAvailability ? 1 : 2;
    // If today is saturday, sunday, then we make sure the first day for delivery be tuesday
    offsetForOrderingAfterCutoff += (currentDateTime == 6) ? 3 : 0;
    offsetForOrderingAfterCutoff += (currentDateTime == 0) ? 2 : 0;

    // On a saturday need too include the price
    let dayToDisplay = offsetForOrderingAfterCutoff;
    let daysShown = 0;

    // Remove all previous options, as we will recalculate them
    deliveryDatePicker.querySelectorAll('option').forEach(option => option.remove());
    if (hasBox == false && (hasFutureItem == false || hasNonFutureFresh == true)) {

      while (daysShown < daysToAllowSelectable) {
        const currentOptionDate = new Date(currentDateTime.getTime() + dayToDisplay * msInADay);
        currentOptionDate.setHours(12, 0, 0, 0);
        // Exclude Sun, and Monday from a delivery date
        if ([0, 1].includes(currentOptionDate.getUTCDay()) == false
          && excludedDates.includes(currentOptionDate.toISOString().split('T')[0]) == false
        ) {
          var o = this.createDeliveryOption(currentOptionDate, selectedDeliveryDate);
          datesAdded.push(currentOptionDate);

          deliveryDatePicker.append(o);

          daysShown++;
        }
        dayToDisplay++;
      }
    }


    // These are the pre-defined dates that are available for delivery set via the theme settings
    if (includedDates.length > 0) {
      let cutOffDate = datesAdded[datesAdded.length - 1] || new Date();
      const datesToInclude = includedDates.map(d => new Date(d)).filter(d => {
        // Check to see if the date is tomorrow or later
        return d > cutOffDate;
      }).map(d => d.toISOString()).sort().map(d => new Date(d));

      if (datesAdded.length > 0) {
        // Add a divider        
        deliveryDatePicker.append(document.createElement('hr'));
      }
      datesToInclude.forEach(d => {
        var o = this.createDeliveryOption(d, selectedDeliveryDate);
        deliveryDatePicker.append(o);
        datesAdded.push(d);
      });
    }

    // set the estimated delivery date
    document.querySelector('.picker-delivery-on').textContent = datesAdded[0].toLocaleDateString(undefined, this.dateFormatOptions);


    deliveryDatePicker.value = selectedDeliveryDate || deliveryDatePicker.querySelector('option').value;

    // If you've got fresh, then the delivery date is the first option
    if (deliveryDatePicker.dataset.hasFresh == 'true') {
      deliveryDatePicker.querySelector('option').selected = true;
    }

    // check to make sure the selected date is still valid

    if (deliveryDatePicker.value == "") {
      deliveryDatePicker.querySelector('option').selected = true;
    }
    const selectedDate = new Date(deliveryDatePicker.value);
    const isSaturdaySelected = selectedDate.getDay() == 6;

    if (this.doesSaturdayHaveAdditionalCost && isSaturdaySelected && deliveryDatePicker.dataset.hasShippingLine == 'false') {
      // Need to add the saturday shipping line item
      this.cartUpdate(deliveryDatePicker.value, { [deliveryDatePicker.dataset.saturdayShippingId]: 1 });
    } else if (this.doesSaturdayHaveAdditionalCost && isSaturdaySelected == false && deliveryDatePicker.dataset.hasShippingLine == 'true') {
      // Need to remove the saturday shipping line item
      this.cartUpdate(deliveryDatePicker.value, { [deliveryDatePicker.dataset.saturdayShippingId]: 0 });
    } else if (deliveryDatePicker.dataset.value == '') {
      this.cartUpdate(deliveryDatePicker.value, {});
    }

  }

  cartUpdate(deliveryDate, updates) {
    const body = JSON.stringify({
      updates: updates,
      attributes: {
        'Delivery Date': deliveryDate
      },
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {

        const parsedState = JSON.parse(state);
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );
        });
        this.populateDeliveryDates();
      }
      );
  }

  createDeliveryOption(currentOptionDate, selectedDeliveryDate) {
    const isSaturday = this.doesSaturdayHaveAdditionalCost && currentOptionDate.getUTCDay() == 6;
    let additionalCost = (this.doesSaturdayHaveAdditionalCost && isSaturday) ? ' - ' + Shopify.formatMoney(this.saturdayCost, '£{{amount}}') : '';
    const dateDisplay = currentOptionDate.toLocaleDateString(undefined, this.dateFormatOptions);
    const optionValue = currentOptionDate.toISOString().substring(0, 10);

    var o = new Option(
      dateDisplay + additionalCost,
      optionValue,
      optionValue == selectedDeliveryDate
    );
    if (isSaturday) {
      o.setAttribute('data-is-saturday', 'true');
    }

    return o;
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === 'cart-items') {
          return;
        }
        this.onCartUpdate();
      },
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
      event.target.dataset.quantityVariantId,
    );
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            'text/html',
          );
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];

          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }

        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            'text/html',
          );
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;

        })
        .catch((e) => {
          console.error(e);
        });
    }


  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.delivery-date-picker',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter)
          cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            'is-empty',
            parsedState.item_count === 0,
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = '';
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              '[quantity]',
              updatedValue,
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);

        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
              cartDrawerWrapper,
              lineItem.querySelector(`[name="${name}"]`),
            )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector('.drawer__inner-empty'),
            cartDrawerWrapper.querySelector('a'),
          );
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector('.cart-item__name'),
          );
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-items',
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) =>
          overlay.classList.add('hidden'),
        );
        const errors =
          document.getElementById('cart-errors') ||
          document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') ||
      document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById('main-cart-items') ||
      document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`,
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`,
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove('hidden'),
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById('main-cart-items') ||
      document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`,
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`,
    );

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add('hidden'),
    );
  }
}
customElements.define('cart-items', CartItems);

class CartDelivery extends HTMLElement {
  constructor() {
    super();
    this.getReferences();
    this.bindEvents();
  }

  getReferences() {
    this.pickUpBtn = this.querySelector('.button--restaurant-pickup');
    if (!this.pickUpBtn) {
      return;
    }
    this.deliveryCheckoutBtn = this.querySelector('.button--delivery');


    this.pickUpCheckoutBtn = this.querySelector('.button--checkout');
    this.pickUpModal = this.querySelector('.dialog--restaurant-pickup')
    this.pickUpModal_ChooseRestaurant = this.querySelector('.dialog--content--choose-restaurant');
    this.pickUpModal_Confirmation = this.querySelector('.dialog--content--confirmation');
    this.pickUpDescription = this.pickUpModal.dataset.pickupDescription;
    this.confirmationText = this.pickUpModal.dataset.confirmationText;
    this.collectionVariantId = this.pickUpModal.dataset.collectionVariantId;
    this.pickUpRestaurantOptions = this.querySelector('.dialog--restaurant-options');
    this.selectedPickUpRestaurant = undefined;
    this.collectionDate = this.calculateCollectionDate();
  }

  calculateCollectionDate() {
    const now = new Date();
    const day = now.getDay();
    const hour = now.getHours();

    if (day >= 1 && day <= 4) { // Monday to Thursday
      if (hour < 14) {
        // Before 14:00, return the next working day
        now.setDate(now.getDate() + 1);
      } else {
        // After 14:00, return two days later
        now.setDate(now.getDate() + 2);
      }
    } else if (day === 5) { // Friday
      if (hour < 12) {
        // Before 12:00, return Saturday
        now.setDate(now.getDate() + 1);
      } else {
        // After 12:00, return Tuesday
        const daysUntilTuesday = (2 - day + 7) % 7;
        now.setDate(now.getDate() + daysUntilTuesday);
      }
    } else if (day === 6 || day === 0) { // Saturday or Sunday
      // Return Tuesday
      const daysUntilTuesday = (2 - day + 7) % 7;
      now.setDate(now.getDate() + daysUntilTuesday);
    }

    return now;
  }


  isValidDateForCollection() {
    const datePicker = document.querySelector('.picker-delivery-date')
    if (datePicker.parentElement.classList.contains('hidden')) {
      // The date picker is hidden, so we dont have a collection date anymore
      return true;
    }

    return document.querySelector('.picker-delivery-date').selectedIndex > -1
  }

  showCheckoutError(error) {
    const pickerCheckout = document.querySelector('.picker-checkout');
    let errorElement = pickerCheckout.querySelector('p.error');
    if (!errorElement) {
      errorElement = document.createElement('p');
      errorElement.className = 'error';
      errorElement.style.color = '#c00';
      errorElement.style.marginBottom = '-0.5rem';
      errorElement.textContent = error;
      pickerCheckout.insertBefore(errorElement, pickerCheckout.firstChild);
    } else {
      errorElement.textContent = error;
      errorElement.classList.remove('hidden');
    }
  }
  showCollectionDateError() {
    this.showCheckoutError('Your choosen delivery date is not valid.  Please select a new one.');
  }
  bindEvents() {
    this.addEventListener('click', (event) => {
      const targetClassList = event.target.classList;
      const isCheckoutForDeliveryButton = targetClassList.contains('button--delivery');
      const isCheckoutForCollectionButton = targetClassList.contains('button--restaurant-pickup')
      if (!this.pickUpBtn) {
        this.getReferences();
      }

      if (isCheckoutForDeliveryButton) {
        event.preventDefault();
        // Make sure that the stored delivery or collection date is valid - ie. not in the past
        if (this.isValidDateForCollection() == false) {
          this.showCollectionDateError();
          return;
        }
        this.removeCollectionProductFromCartThenCheckout();
      }

      if (isCheckoutForCollectionButton) {
        event.preventDefault();
        this.showChooseRestaurant();

        if (this.pickUpModal && typeof this.pickUpModal.showModal === 'function') {
          if (!document.body.contains(this.pickUpModal)) {
            document.body.appendChild(this.pickUpModal);
          }
          this.pickUpModal.showModal();
        } else {
          console.error('Dialog element or showModal method is not supported.');
        }
      }

    }, { capture: true });

    [...this.querySelectorAll('.button--close')].forEach((button) => {
      button.addEventListener('click', (event) => {
        this.cancelCollection();
      });
    });

    this.pickUpRestaurantOptions.addEventListener('click', (event) => {
      const selectedRestaurant = event.target.closest('.button');
      if (selectedRestaurant) {
        this.selectedPickUpRestaurant = selectedRestaurant.dataset.restaurant;
        this.showConfirmation();
      }
    });


    this.pickUpCheckoutBtn.addEventListener('click', (event) => {
      this.addCollectionProductToCart();
      event.preventDefault();
    });
  }

  addCollectionProductToCart() {
    const FROM_RESTAURANT_PROPERTY = 'Restaurant';

    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const existingCollectionProduct = cart.items.find(item => item.variant_id === parseInt(this.collectionVariantId));
        if (!existingCollectionProduct) {
          // No product, add the product with the FROM_RESTAURANT_PROPERTY set
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: this.collectionVariantId,
              quantity: 1,
              properties: { [FROM_RESTAURANT_PROPERTY]: this.selectedPickUpRestaurant },
            }),
          })
            .then(() => {
              window.location.href = '/checkout';
            })
            .catch((error) => {
              console.error('Error adding product to cart:', error);
            });
        } else if (existingCollectionProduct.properties[FROM_RESTAURANT_PROPERTY] !== this.selectedPickUpRestaurant) {
          // Product with a different property value, update the product with the correct value
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: existingCollectionProduct.key,
              quantity: existingCollectionProduct.quantity,
              properties: { [FROM_RESTAURANT_PROPERTY]: this.selectedPickUpRestaurant },
            }),
          })
            .then(() => {
              window.location.href = '/checkout';
            })
            .catch((error) => {
              console.error('Error updating product in cart:', error);
            });
        } else {
          // Otherwise, do nothing and go to checkout
          window.location.href = '/checkout';
        }

      })
      .catch((error) => {
        console.error('Error fetching cart items:', error);
      });

  }

  removeCollectionProductFromCartThenCheckout() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const existingCollectionProduct = cart.items.find(item => item.variant_id === parseInt(this.collectionVariantId));
        if (existingCollectionProduct) {
          // Remove the collection product from the cart
          fetch(`/cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: existingCollectionProduct.key,
              quantity: 0,
            }),
          });
        }
        window.location.href = '/checkout';
      });
  }
  setCollectionDate(text) {
    const formattedDate = this.collectionDate.toLocaleDateString(undefined, {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
    });
    return text.replace('[ deliveryDate | date: "%a, %e %b" ]', formattedDate);
  }
  showChooseRestaurant() {
    const description = this.setCollectionDate(this.pickUpDescription);
    this.pickUpModal_ChooseRestaurant.querySelector('.dialog--description').innerHTML = description;
    this.pickUpModal_ChooseRestaurant.classList.add('visible');
    this.pickUpModal_Confirmation.classList.remove('visible');
  }
  showConfirmation() {
    let confirmationText = this.confirmationText.replace('[RestaurantName]', this.selectedPickUpRestaurant);
    confirmationText = this.setCollectionDate(confirmationText);
    this.pickUpModal_Confirmation.querySelector('.dialog--description').innerHTML = confirmationText;

    this.pickUpModal_Confirmation.classList.add('visible');
    this.pickUpModal_ChooseRestaurant.classList.remove('visible');
  }
  cancelCollection() {
    this.pickUpModal_Confirmation.classList.remove('visible');
    this.pickUpModal_ChooseRestaurant.classList.remove('visible');
    this.pickUpModal.close();
  }
}
customElements.define('cart-delivery', CartDelivery);


if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.doesSaturdayHaveAdditionalCost = false;

        this.addEventListener(
          'input',
          debounce((event) => {
            this.updatedCartDetails();
          }, ON_CHANGE_DEBOUNCE_TIMER),
        );
      }

      updatedCartDetails() {

        let deliveryDayCartUpdates = undefined;
        const deliveryDate = document.querySelector('.delivery-date-picker select[name="attributes[Delivery Date]"]');

        const isDeliveryDateSaturday = deliveryDate.selectedOptions[0].getAttribute('data-is-saturday') == 'true';
        const pickerDataset = document.querySelector('.picker-delivery-date').dataset;
        const hasOnlyVirtualItems = pickerDataset?.hasOnlyVirtual == 'true';
        const hasShippingLineItem = pickerDataset?.hasShippingLine == 'true';
        const shippingVariantId = pickerDataset?.saturdayShippingId;
        if (this.doesSaturdayHaveAdditionalCost) {
          if (isDeliveryDateSaturday && hasShippingLineItem == false) {
            // Is a saturday, but we have no shipping line item
            deliveryDayCartUpdates = { [shippingVariantId]: 1 };
          } else if (isDeliveryDateSaturday == false && hasShippingLineItem) {
            // Not a saturday, but we have a shipping line item
            deliveryDayCartUpdates = { [shippingVariantId]: 0 };
          } else if (isDeliveryDateSaturday && hasShippingLineItem && hasOnlyVirtualItems) {
            // Only virtual items, but has satuday shipping
            deliveryDayCartUpdates = { [shippingVariantId]: 0 };
          }
        }

        const sectionId = document.getElementById('main-cart-items').dataset.id;
        const body = JSON.stringify({
          note: document.querySelector('.cart__note  textarea[name="note"]')?.value,
          attributes: {
            'Delivery Date': document.querySelector('.delivery-date-picker select[name="attributes[Delivery Date]"]').value
          },
          updates: deliveryDayCartUpdates,
          sections: [sectionId],
        });

        fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          ...{ body },
        }).then((response) => {
          return response.text();
        })
          .then((state) => {
            const parsedState = JSON.parse(state);

            this.getSectionsToRender().forEach((section) => {
              const elementToReplace = document.querySelector(section.replaceTo);

              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[sectionId],
                section.replaceFrom,
              );
            });
            publish('delivery-date-update');

          });
      }

      getSectionsToRender() {
        return [
          {
            id: 'main-cart-items',
            replaceFrom: '.delivery-date-picker',
            replaceTo: '.delivery-date-picker',
          },
          {
            id: 'main-cart-items',
            replaceFrom: '.cart__items .js-contents',
            replaceTo: '#main-cart-items .js-contents',
          }
        ];
      }

      getSectionInnerHTML(html, selector) {
        return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector).innerHTML;
      }
    },
  );
}
